import { createAsyncThunk, createSlice } from '@reduxjs/toolkit'
import moment from 'moment/moment'
import { apiPickupsList, apiPickupsView } from 'Services/AdminService'
import { dataDefault } from 'Views/Admin/Pickups/Pallets'

export const getData = createAsyncThunk('admin/pickups/getData', async datas => {
    const { data } = await apiPickupsList(datas)
    return data
})

export const getView = createAsyncThunk('admin/pickups/getView', async id => {
    if (!id) return viewData
    const { data } = await apiPickupsView(id)
    data.images = []
    data.image_remove = []
    data.documents = []
    data.document_remove = []
    data.pallets = data.pallets && data.pallets.length !== 0 ? data.pallets : [dataDefault]
    return data
})

const viewData = {
    collection_point_id: '',
    comment: '',
    images: [],
    image_remove: [],
    pallets: [dataDefault],
}

export const pickupsSlice = createSlice({
    name: 'admin/pickups',
    initialState: {
        loading: true,
        view: viewData,
        data: [],
        total: 0,
        table: {
            page: 1,
            length: 10,
            search: '',
            column: '',
            dir: '',
            status: '',
            start: moment().startOf('month').locale('en').format('YYYY-MM-DD'),
            end: moment().endOf('month').locale('en').format('YYYY-MM-DD'),
        },
    },
    reducers: {
        setData: (state, { payload }) => {
            state.data = payload
        },
        setTableData: (state, { payload }) => {
            state.table = payload
        },
        setStatus: (state, { payload }) => {
            state.table.page = 1
            state.table.status = payload
        },
        setDate: (state, { payload: { start, end } }) => {
            state.table.page = 1
            state.table.start = start
            state.table.end = end
        },
    },
    extraReducers: builder => {
        builder
            .addCase(getData.pending, state => {
                state.loading = true
            })
            .addCase(getData.fulfilled, (state, { payload }) => {
                state.loading = false
                state.data = payload.data
                state.total = payload.total
            })
            .addCase(getData.rejected, state => {
                state.loading = false
                state.data = []
                state.total = 0
            })
            .addCase(getView.pending, state => {
                state.loading = true
                state.view = viewData
            })
            .addCase(getView.fulfilled, (state, { payload }) => {
                state.loading = false
                state.view = payload
            })
    },
})

export const { setData, setTableData, setStatus, setDate } = pickupsSlice.actions

export default pickupsSlice.reducer
